import { mapState, mapActions } from 'vuex'
import router from '@/router'
import { cloneDeep } from 'lodash'
import templateAddEditContent from '@/components/pages/main-pages/settings/templates/template-add-edit-content/template-add-edit-content.vue'

export default {
  components: {
    templateAddEditContent
  },
  data() {
    return {
      template: {
        name: null,
        desc: null,
        preparation_time: null,
        mechanic_id: null,
        design: null,
        image: null,
        created_by: null,
        age: null,
        language: null,
        workflow_id: null,
        default_timezone: null,
        design_type: null,
        design_config: {},
        design_details: {}
      }
    }
  },
  computed: {
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('user', ['currentUser'])
  },
  methods: {
    ...mapActions('template', ['createTemplate']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    onCreateTemplate: async function () {
      try {
        const newTemplate = cloneDeep(this.template)
        newTemplate.mechanic_id = newTemplate.mechanic.id
        delete newTemplate.mechanic
        newTemplate.age = newTemplate.age.name
        newTemplate.created_by = this.currentUser.id
        newTemplate.workflow_id = newTemplate.workflow.id
        delete newTemplate.workflow
        await this.createTemplate(newTemplate)
        this.$notify({
          text: 'Template created',
          type: 'success'
        })
        router.push({ name: 'templates' })
      } catch (e) {
        this.$notify({
          text: 'Error while creating template',
          type: 'error'
        })
      }
    },
    cancel: function () {
      router.push({ name: 'templates' })
    }
  },
  async created() {
    if (this.mechanicList.length === 0) {
      this.getMechanicList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/templates/template-add/template-add.js